import { render, staticRenderFns } from "./RateAndReview.vue?vue&type=template&id=68760af7"
import script from "./RateAndReview.vue?vue&type=script&lang=js"
export * from "./RateAndReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports